import React from 'react'
import styles from './LanguageSelector.module.css'
import Dropdown from '../../../Dropdown'
import { getLocales, faLocale } from '../../../../../../utilities/locales'
import translate from '../../../../../../utilities/translate'
import translations from './translations'
import PropTypes from 'prop-types'

const trans = translate(translations)

const LanguageSelector = ({ locale, changeLanguage }) =>
  <div className={ styles.wrapper }>
    <Dropdown>
      <Dropdown.Toggle>
        <span className={ styles.locale }>{ locale }</span>
      </Dropdown.Toggle>
      <Dropdown.Menu>
        { getLocales().filter(l => locale === faLocale ? true : l !== faLocale).map(l =>
          <Dropdown.Menu.ExternalLink
            key={ l }
            href={ `/${l}` }
            openInNewPage={ false }
            handleClick={ () => changeLanguage(l) }
            isActive={ locale === l }
          >
            { trans(locale)(l) }
          </Dropdown.Menu.ExternalLink>,
        ) }
      </Dropdown.Menu>
    </Dropdown>
  </div>

LanguageSelector.propTypes = {
  locale: PropTypes.oneOf(getLocales()).isRequired,
  changeLanguage: PropTypes.func.isRequired,
}

export default LanguageSelector
